import { useWatch } from 'react-hook-form';

import { Flex, Stack } from '@ui';

import { AdaptiveFormRows } from './AdaptiveFormRows';
import {
  AdaptiveFormFieldConfigBase,
  AdaptiveFormNestableFieldConfig
} from './types';

type AdaptiveNestedCheckboxFormProps = {
  config: AdaptiveFormNestableFieldConfig & Partial<AdaptiveFormFieldConfigBase>;
};

const AdaptiveNestedCheckboxForm = ({ config }: AdaptiveNestedCheckboxFormProps) => {
  if (!config?.name) return null;
  const value = useWatch({ name: config.name });

  if (!config.fields?.length || !value) return null;

  return (
    <Flex gap={0} direction="column" justify="center" wrap="nowrap">
      <AdaptiveFormRows config={config.fields} />
    </Flex>
  );
};

export type CheckboxFormWrapperProps = {
  config: AdaptiveFormNestableFieldConfig & Partial<AdaptiveFormFieldConfigBase>;
  children?: React.ReactNode;
};

export const WithNestedFormFieldsForCheckbox = ({
  children,
  config
}: CheckboxFormWrapperProps) => {
  return (
    <Stack gap={20} w="100%">
      {children}
      <AdaptiveNestedCheckboxForm config={config} />
    </Stack>
  );
};
